import LoginArea from './LoginArea'

export default LoginArea
